import { getCookie, setCookie, deleteCookie } from '../utils/cookie';
import { otherEvents } from './constants/otherEvents';
import { ee } from '../eventEmitter';

const EL_SELECTOR = '#cookie-plate';
const COOKIE_NAME = 'cookie-policy-accepted';

export default class AppCookiePlate {
    #el;
    #closeButtonEl;
    #isAgreed = false;

    constructor() {
        this.#el = document.querySelector(EL_SELECTOR);
        this.#closeButtonEl = this.#el.querySelector('.js-cookie-plate-close');

        // this.clearCookie();

        this.checkCookie();
        this.bindEvents();
    }

    bindEvents() {
        this.#closeButtonEl.addEventListener('click', this.aceptCookies.bind(this));
    }

    aceptCookies() {
        const expDays = 365;
        const expDate = new Date();

        expDate.setDate(expDate.getDate() + expDays);

        this.hidePlate();
        setCookie(COOKIE_NAME, '1', { expires: expDate });
        ee.emit(otherEvents.COOKIE_POLICY_ACCEPT);
    }

    checkCookie() {
        this.#isAgreed = getCookie(COOKIE_NAME);

        if (!this.#isAgreed) {
            this.showPlate();
        } else {
            ee.emit(otherEvents.COOKIE_POLICY_ACCEPT);
        }
    }

    // eslint-disable-next-line class-methods-use-this
    clearCookie() {
        deleteCookie(COOKIE_NAME);
    }

    showPlate() {
        this.#el.classList.add('visible');
    }

    hidePlate() {
        this.#el.classList.remove('visible');
    }
}
